import { render, staticRenderFns } from "./cart-item-legal.vue?vue&type=template&id=40698970&"
import script from "./cart-item-legal.vue?vue&type=script&lang=js&"
export * from "./cart-item-legal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/sites/www/new.crt.ru/html/current_version/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40698970')) {
      api.createRecord('40698970', component.options)
    } else {
      api.reload('40698970', component.options)
    }
    module.hot.accept("./cart-item-legal.vue?vue&type=template&id=40698970&", function () {
      api.rerender('40698970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/components/cart-item-legal/cart-item-legal.vue"
export default component.exports